import { UserType } from '../types';

type EmployeeSections = 'dashboard' | 'jobs' | 'profile' | 'documents';

const basePaths: Record<EmployeeSections, string> = {
  dashboard: '/employee/dashboard',
  jobs: '/employee/jobs',
  profile: '/employee/profile',
  documents: '/employee/documents'
};

const roleSpecificPaths: Record<EmployeeSections, Partial<Record<UserType, string>>> = {
  dashboard: {
    employee: '/employee/dashboard/maintenance',
    customer_service: '/employee/dashboard/customer-service',
    administrative_staff: '/employee/dashboard/administrative',
    finance_staff: '/employee/dashboard/finance'
  },
  jobs: {
    employee: '/employee/jobs/maintenance',
    customer_service: '/employee/jobs/customer-service',
    administrative_staff: '/employee/jobs/administrative',
    finance_staff: '/employee/jobs/finance'
  },
  profile: {
    employee: '/employee/profile/maintenance',
    customer_service: '/employee/profile/customer-service',
    administrative_staff: '/employee/profile/administrative',
    finance_staff: '/employee/profile/finance'
  },
  documents: {
    administrative_staff: '/employee/documents/administrative'
  }
};

export const getEmployeeRoute = (section: EmployeeSections, userType?: UserType | null) => {
  if (!userType) return basePaths[section];
  const overrides = roleSpecificPaths[section];
  return overrides[userType] ?? basePaths[section];
};

